import React, { useContext, useState } from "react";
import { AiOutlineHome } from "react-icons/ai";
import { FaBars, FaToolbox } from "react-icons/fa";
import { GiClothes } from "react-icons/gi";
import { IoCartSharp } from "react-icons/io5";
import { MdDashboardCustomize, MdStar } from "react-icons/md";
import { RiCoupon3Fill, RiLogoutCircleFill } from "react-icons/ri";
import { RxCross2 } from "react-icons/rx";
import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { UserContext } from "../../App";

const menu = [
  { name: "Home", icon: <AiOutlineHome className="h-6 w-6" />, route: "/dashboard", end: true },
  { name: "Manage Products", icon: <FaToolbox className="h-6 w-6" />, route: "/dashboard/manage-products" },
  { name: "Add Clothes", icon: <GiClothes className="h-6 w-6" />, route: "/dashboard/manage-clothes" },
  { name: "Manage Categories", icon: <MdDashboardCustomize className="h-6 w-6" />, route: "/dashboard/manage-categories" },
  { name: "Manage Orders", icon: <IoCartSharp className="h-6 w-6" />, route: "/dashboard/manage-orders" },
  { name: "Manage Featureds", icon: <MdStar className="h-6 w-6" />, route: "/dashboard/manage-featureds" },
  { name: "Manage Coupons", icon: <RiCoupon3Fill className="h-6 w-6" />, route: "/dashboard/manage-coupons" },
];

function Layout() {
  const [showNav, setShowNav] = useState(false);
  const { setUser } = useContext(UserContext);
  const navigate = useNavigate();

  const closeNav = () => setShowNav(false);
  const logout = () => {
    localStorage.removeItem("token");
    setUser(null);
    navigate("/");
  };

  const linkClass = ({ isActive }) =>
    `flex items-center gap-x-4 rounded-lg px-4 py-2.5 transition-colors ${
      isActive
        ? "bg-gray-800 font-medium text-white"
        : "text-gray-400 hover:bg-gray-800/60 hover:text-white"
    }`;

  const navList = (onClick) => (
    <ul className="flex flex-1 flex-col gap-y-1.5">
      {menu.map((item) => (
        <li key={item.route}>
          <NavLink to={item.route} end={item.end} onClick={onClick} className={linkClass}>
            {item.icon}
            <span>{item.name}</span>
          </NavLink>
        </li>
      ))}
      <li>
        <button
          onClick={() => {
            onClick?.();
            logout();
          }}
          className="mt-2 flex w-full items-center gap-x-4 rounded-lg px-4 py-2.5 text-gray-400 transition-colors hover:bg-gray-800/60 hover:text-white"
        >
          <RiLogoutCircleFill className="h-6 w-6" />
          <span>Logout</span>
        </button>
      </li>
    </ul>
  );

  return (
    <div className="flex h-screen w-full overflow-hidden bg-gray-800 font-sans">
      {/* Desktop sidebar */}
      <aside className="hidden w-64 shrink-0 flex-col bg-gray-700 px-4 pt-8 pb-6 lg:flex">
        <NavLink
          to="/dashboard"
          end
          className="mb-10 px-4 text-xl font-semibold text-white focus:outline-none"
        >
          Emporium Central
        </NavLink>
        {navList()}
      </aside>

      {/* Mobile drawer + backdrop */}
      <div
        className={`fixed inset-0 z-40 bg-black/50 transition-opacity lg:hidden ${
          showNav ? "opacity-100" : "pointer-events-none opacity-0"
        }`}
        onClick={closeNav}
        aria-hidden="true"
      />
      <aside
        className={`fixed inset-y-0 left-0 z-50 flex w-64 max-w-[80%] flex-col bg-gray-700 px-4 pt-8 pb-6 shadow-xl transition-transform duration-300 lg:hidden ${
          showNav ? "translate-x-0" : "-translate-x-full"
        }`}
      >
        <div className="mb-10 flex items-center justify-between px-4">
          <span className="text-xl font-semibold text-white">Emporium Central</span>
          <button onClick={closeNav} aria-label="Close menu" className="text-gray-300 hover:text-white">
            <RxCross2 className="h-6 w-6" />
          </button>
        </div>
        {navList(closeNav)}
      </aside>

      {/* Main section */}
      <main className="noScrollbar flex max-h-screen flex-1 flex-col overflow-y-auto bg-gray-800">
        <nav className="sticky top-0 z-30 flex items-center justify-between gap-x-6 bg-gray-700 px-4 py-4 lg:px-8">
          <button
            onClick={() => setShowNav(true)}
            aria-label="Open menu"
            className="text-white lg:hidden"
          >
            <FaBars className="h-6 w-6" />
          </button>
          <h1 className="text-xl font-bold text-white lg:text-2xl">Emporium Central</h1>
        </nav>

        <div className="px-4 pb-10 sm:px-6 lg:px-8">
          <Outlet />
        </div>
      </main>
    </div>
  );
}

export default Layout;
